import { PageSubtitle, PageTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import { marginBottom, paddingV } from '@sleepstation/style-api-helpers'
import { constrainNarrow, defaultBorder } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  as: `header`,
  spacing: 0.5,
})`
  ${marginBottom(1)}
  ${constrainNarrow()}
`

const NavWrapper = styled(VLayout).attrs({
  as: `nav`,
  align: LAYOUT_ALIGN.LEFT,
})`
  ${defaultBorder(`bottom`)}
  ${paddingV(0.5)}
  ${marginBottom(1)}
  width: 100%;
`

const Title = styled(PageTitle)`
  position: relative;
  z-index: 1;
  max-width: 100%;

  ${NavWrapper} + & {
    margin-top: 0;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PageHeader = ({ title, subtitle }) => (
  <Layout align={LAYOUT_ALIGN.LEFT}>
    <Title data-cy="page-title" align={LAYOUT_ALIGN.LEFT}>
      {title}
    </Title>
    {subtitle && (
      <PageSubtitle align={LAYOUT_ALIGN.LEFT}>{subtitle}</PageSubtitle>
    )}
  </Layout>
)

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

PageHeader.defaultProps = {
  subtitle: null,
}

export default PageHeader
